import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LocalizationService } from '../../core/localization/localization.service';
import { AinPageComponent } from '../../shared/design-system/page.component';

@Component({
  standalone: true,
  selector: 'ain-catalog',
  imports: [AinPageComponent, RouterLink],
  template: `
    <ain-page
      [eyebrow]="t('catalog.eyebrow')"
      [title]="t('catalog.title')"
      [description]="t('catalog.description')">
      <section class="grid">
        <a class="card highlight" [routerLink]="['/operations/control-room']">
          <h3>{{ t('catalog.workspace.controlRoom.title') }}</h3>
          <p>{{ t('catalog.workspace.controlRoom.description') }}</p>
        </a>
        <a class="card highlight" [routerLink]="['/catalog/products']">
          <h3>{{ t('catalog.products.hub.title') }}</h3>
          <p>{{ t('catalog.products.hub.description') }}</p>
        </a>
        <a class="card" [routerLink]="['/inventory/warehouses']">
          <h3>{{ t('catalog.workspace.warehouses.title') }}</h3>
          <p>{{ t('catalog.workspace.warehouses.description') }}</p>
        </a>
        <a class="card" [routerLink]="['/inventory/movements']">
          <h3>{{ t('catalog.workspace.movements.title') }}</h3>
          <p>{{ t('catalog.workspace.movements.description') }}</p>
        </a>
        <a class="card" [routerLink]="['/inventory/count-sessions']">
          <h3>{{ t('catalog.workspace.counts.title') }}</h3>
          <p>{{ t('catalog.workspace.counts.description') }}</p>
        </a>
        <a class="card" [routerLink]="['/inventory/internal-consumption']">
          <h3>{{ t('catalog.workspace.internalConsumption.title') }}</h3>
          <p>{{ t('catalog.workspace.internalConsumption.description') }}</p>
        </a>
        <a class="card" [routerLink]="['/inventory/lots']">
          <h3>{{ t('catalog.workspace.lots.title') }}</h3>
          <p>{{ t('catalog.workspace.lots.description') }}</p>
        </a>
        <a class="card" [routerLink]="['/inventory/serials']">
          <h3>{{ t('catalog.workspace.serials.title') }}</h3>
          <p>{{ t('catalog.workspace.serials.description') }}</p>
        </a>
        <a class="card" [routerLink]="['/inventory/qc-inspections']">
          <h3>{{ t('catalog.workspace.qc.title') }}</h3>
          <p>{{ t('catalog.workspace.qc.description') }}</p>
        </a>
        <a class="card" [routerLink]="['/inventory/traceability']">
          <h3>{{ t('catalog.workspace.traceability.title') }}</h3>
          <p>{{ t('catalog.workspace.traceability.description') }}</p>
        </a>
        <a class="card" [routerLink]="['/inventory/recalls']">
          <h3>{{ t('catalog.workspace.recalls.title') }}</h3>
          <p>{{ t('catalog.workspace.recalls.description') }}</p>
        </a>
        <a class="card" [routerLink]="['/services/orders']">
          <h3>{{ t('catalog.workspace.serviceOrders.title') }}</h3>
          <p>{{ t('catalog.workspace.serviceOrders.description') }}</p>
        </a>
        <a class="card" [routerLink]="['/services/resources']">
          <h3>{{ t('catalog.workspace.serviceResources.title') }}</h3>
          <p>{{ t('catalog.workspace.serviceResources.description') }}</p>
        </a>
        <a class="card" [routerLink]="['/services/rma']">
          <h3>{{ t('catalog.workspace.rma.title') }}</h3>
          <p>{{ t('catalog.workspace.rma.description') }}</p>
        </a>
        <a class="card" [routerLink]="['/assets/register']">
          <h3>{{ t('catalog.workspace.assets.title') }}</h3>
          <p>{{ t('catalog.workspace.assets.description') }}</p>
        </a>
        <a class="card" [routerLink]="['/rental/agreements']">
          <h3>{{ t('catalog.workspace.rental.title') }}</h3>
          <p>{{ t('catalog.workspace.rental.description') }}</p>
        </a>
        <a class="card" [routerLink]="['/rental/booking-board']">
          <h3>{{ t('catalog.rental.bookingBoard.title') }}</h3>
          <p>{{ t('catalog.rental.bookingBoard.description') }}</p>
        </a>
        <a class="card" [routerLink]="['/cmms/work-orders']">
          <h3>{{ t('catalog.workspace.cmms.title') }}</h3>
          <p>{{ t('catalog.workspace.cmms.description') }}</p>
        </a>
        <a class="card" [routerLink]="['/cmms/plans']">
          <h3>{{ t('catalog.cmms.plans.title') }}</h3>
          <p>{{ t('catalog.cmms.plans.description') }}</p>
        </a>
      </section>
    </ain-page>
  `,
  styles: [`
    .grid { display: grid; gap: 12px; grid-template-columns: repeat(auto-fit, minmax(260px, 1fr)); }
    .card { border: 1px solid #e2e8f0; border-radius: 12px; padding: 14px; text-decoration: none; color: inherit; }
    .card:hover { border-color: #3b82f6; box-shadow: 0 8px 24px rgb(37 99 235 / 10%); }
    .card h3 { margin: 0 0 8px; }
    .card p { margin: 0; color: #64748b; }
    .card.highlight { border-color: #2563eb; background: #eff6ff; }
  `]
})
export class CatalogComponent {
  private readonly localizationService = inject(LocalizationService);

  t(key: string): string {
    return this.localizationService.translate(key);
  }
}
